(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initializeProductStories = (scope = document) => {
      scope.querySelectorAll('[data-yn-product-story]').forEach((story) => {
        if (story.dataset.ynStoryReady === 'true') return;
        story.dataset.ynStoryReady = 'true';

        const normalizeTitle = (value) =>
          (value || '')
            .trim()
            .toLocaleLowerCase()
            .replace(/[\u2014\u2013-]/g, ' ')
            .replace(/\s+/g, ' ');

        const productTitle = normalizeTitle(story.dataset.productTitle);
        if (productTitle) {
          story.querySelectorAll('.yn-product-story__content .rte h2, .yn-product-story__content .rte h3').forEach((heading) => {
            const headingText = normalizeTitle(heading.textContent);
            if (headingText !== productTitle) return;
            heading.dataset.ynDuplicateTitle = 'true';
            heading.hidden = true;
          });
        }

      });
    };

    initializeProductStories();
    document.addEventListener('shopify:section:load', (event) => initializeProductStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-collection"]) return;
  try {
    
  (() => {
    const initializeCollections = (scope = document) => {
      scope.querySelectorAll('[data-yn-collection]').forEach((collection) => {
        if (collection.dataset.ynReady === 'true') return;
        collection.dataset.ynReady = 'true';

        const form = collection.querySelector('.yn-collection__form');
        const sort = collection.querySelector('[data-yn-collection-sort]');

        if (form && sort) {
          sort.addEventListener('change', () => form.requestSubmit());
        }
      });
    };

    initializeCollections();
    document.addEventListener('shopify:section:load', (event) => initializeCollections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-editorial-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDetails = (scope = document) => {
      scope.querySelectorAll('[data-yn-details]').forEach((root) => {
        if (root.dataset.detailsReady === 'true') return;
        const tabs = Array.from(root.querySelectorAll('[data-detail-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-detail-panel]'));
        const currentLabel = root.querySelector('[data-detail-current]');
        if (!tabs.length || !panels.length || !currentLabel) return;

        const select = (key) => {
          tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.detailTab === key)));
          panels.forEach((panel) => {
            const active = panel.dataset.detailPanel === key;
            panel.classList.toggle('is-active', active);
          });
          currentLabel.textContent = String(key).padStart(2, '0');
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => select(tab.dataset.detailTab));
          tab.addEventListener('mouseenter', () => {
            if (matchMedia('(hover: hover)').matches) select(tab.dataset.detailTab);
          });
        });

        select('1');
        root.dataset.detailsReady = 'true';
      });
    };

    initializeDetails();
    document.addEventListener('shopify:section:load', (event) => initializeDetails(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-fit-studio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFitStudios = (scope = document) => {
      scope.querySelectorAll('[data-yn-fit-studio]').forEach((studio) => {
        if (studio.dataset.ynReady === 'true') return;
        studio.dataset.ynReady = 'true';

        const tabs = studio.querySelectorAll('[data-yn-fit-tab]');
        const panels = studio.querySelectorAll('[data-yn-fit-panel]');

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const mode = tab.dataset.ynFitTab;

            tabs.forEach((candidate) => {
              candidate.setAttribute('aria-selected', String(candidate === tab));
            });

            panels.forEach((panel) => {
              panel.hidden = panel.dataset.ynFitPanel !== mode;
            });
          });
        });
      });
    };

    initializeFitStudios();
    document.addEventListener('shopify:section:load', (event) => initializeFitStudios(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-footer-v3"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-yn3-localization-select]').forEach((select) => {
      select.addEventListener('change', () => select.form && select.form.submit());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-frame-lab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFrameLabs = (scope = document) => {
      scope.querySelectorAll('[data-yn-frame-lab]').forEach((lab) => {
        if (lab.dataset.ynReady === 'true') return;
        lab.dataset.ynReady = 'true';

        const shapeButtons = Array.from(lab.querySelectorAll('[data-face-shape]'));
        const faceVisual = lab.querySelector('[data-face-visual]');
        const shapeTitle = lab.querySelector('[data-shape-title]');
        const shapeCopy = lab.querySelector('[data-shape-copy]');
        const shapeTag = lab.querySelector('[data-shape-tag]');
        const faceFrames = Array.from(lab.querySelectorAll('[data-face-frame]'));

        const setFaceShape = (button) => {
          shapeButtons.forEach((candidate) => {
            candidate.setAttribute('aria-selected', String(candidate === button));
          });
          faceVisual.dataset.faceShape = button.dataset.faceShape;
          faceFrames.forEach((frame) => {
            frame.classList.toggle('is-active', frame.dataset.faceFrame === button.dataset.frameShape);
          });
          shapeTitle.textContent = button.dataset.resultTitle;
          shapeCopy.textContent = button.dataset.resultCopy;
          shapeTag.textContent = button.dataset.resultTag;
        };

        shapeButtons.forEach((button, index) => {
          button.addEventListener('click', () => setFaceShape(button));
          button.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            event.preventDefault();
            const direction = event.key === 'ArrowRight' ? 1 : -1;
            const next = shapeButtons[(index + direction + shapeButtons.length) % shapeButtons.length];
            next.focus();
            setFaceShape(next);
          });
        });

        const sizeRange = lab.querySelector('[data-size-range]');
        const sizeValue = lab.querySelector('[data-size-value]');
        const sizeMeasure = lab.querySelector('[data-size-measure]');
        const sizeVisual = lab.querySelector('[data-size-visual]');
        const sizeTitle = lab.querySelector('[data-size-title]');
        const sizeCopy = lab.querySelector('[data-size-copy]');
        const sizeCards = Array.from(lab.querySelectorAll('[data-size-card]'));

        const updateSize = () => {
          const value = Number(sizeRange.value);
          const key = value <= 141 ? 'narrow' : value <= 148 ? 'standard' : 'wide';
          const normalized = (value - 134) / 22;
          const scale = 0.82 + normalized * 0.34;
          const titleKey = `size${key.charAt(0).toUpperCase()}${key.slice(1)}Title`;
          const copyKey = `size${key.charAt(0).toUpperCase()}${key.slice(1)}Copy`;

          sizeValue.textContent = `${value} mm`;
          sizeMeasure.textContent = `${value} mm`;
          sizeVisual.style.setProperty('--sim-scale', scale.toFixed(3));
          sizeTitle.textContent = lab.dataset[titleKey];
          sizeCopy.textContent = lab.dataset[copyKey];
          sizeCards.forEach((card) => {
            card.classList.toggle('is-active', card.dataset.sizeCard === key);
          });
        };

        sizeRange.addEventListener('input', updateSize);
        updateSize();

        const tryStage = lab.querySelector('[data-try-stage]');
        const tryFrame = lab.querySelector('[data-try-frame]');
        const tryPhoto = lab.querySelector('[data-try-photo]');
        const tryPlaceholder = lab.querySelector('[data-try-placeholder]');
        const tryUpload = lab.querySelector('[data-try-upload]');
        const tryReset = lab.querySelector('[data-try-reset]');
        const tryStyles = Array.from(lab.querySelectorAll('[data-try-style]'));
        const tryShapes = Array.from(lab.querySelectorAll('[data-try-shape]'));
        const tryColors = Array.from(lab.querySelectorAll('[data-try-color]'));
        const tryScale = lab.querySelector('[data-try-scale]');
        const tryY = lab.querySelector('[data-try-y]');
        let objectUrl = '';

        const setTryStyle = (button) => {
          tryStyles.forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-pressed', String(active));
          });
          tryShapes.forEach((shape) => {
            shape.classList.toggle('is-active', shape.dataset.tryShape === button.dataset.tryStyle);
          });
        };

        tryStyles.forEach((button) => {
          button.addEventListener('click', () => setTryStyle(button));
        });

        tryColors.forEach((button) => {
          button.addEventListener('click', () => {
            tryColors.forEach((candidate) => {
              const active = candidate === button;
              candidate.classList.toggle('is-active', active);
              candidate.setAttribute('aria-pressed', String(active));
            });
            tryStage.style.setProperty('--try-color', button.dataset.tryColor);
          });
        });

        const updateTryPosition = () => {
          tryStage.style.setProperty('--try-scale', String(Number(tryScale.value) / 100));
          tryStage.style.setProperty('--try-y', `${tryY.value}%`);
        };

        tryScale.addEventListener('input', updateTryPosition);
        tryY.addEventListener('input', updateTryPosition);

        tryUpload.addEventListener('change', () => {
          const file = tryUpload.files && tryUpload.files[0];
          if (!file) return;
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          objectUrl = URL.createObjectURL(file);
          tryPhoto.src = objectUrl;
          tryPhoto.hidden = false;
          tryPlaceholder.hidden = true;
        });

        tryReset.addEventListener('click', () => {
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          objectUrl = '';
          tryUpload.value = '';
          tryPhoto.removeAttribute('src');
          tryPhoto.hidden = true;
          tryPlaceholder.hidden = false;
          tryScale.value = '100';
          tryY.value = '43';
          updateTryPosition();
        });

        updateTryPosition();
      });
    };

    initializeFrameLabs();
    document.addEventListener('shopify:section:load', (event) => initializeFrameLabs(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeYouNickHomeProducts = (scope = document) => {
      scope.querySelectorAll('[data-yn-home-products]').forEach((section) => {
        if (section.dataset.ynProductsReady === 'true') return;
        section.dataset.ynProductsReady = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-yn-products-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-yn-products-panel]'));

        const activate = (tab, moveFocus = false) => {
          const key = tab.dataset.ynProductsTab;
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          panels.forEach((panel) => {
            const selected = panel.dataset.ynProductsPanel === key;
            panel.hidden = !selected;
            if (selected) panel.querySelector('[data-yn-products-track]')?.scrollTo({ left: 0 });
          });
          if (moveFocus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === null) return;
            event.preventDefault();
            activate(tabs[nextIndex], true);
          });
        });

        panels.forEach((panel) => {
          const track = panel.querySelector('[data-yn-products-track]');
          if (!track) return;
          const scroll = (direction) => {
            const card = track.querySelector('.yn-card');
            const amount = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * 0.82;
            track.scrollBy({ left: direction * amount, behavior: 'smooth' });
          };
          panel.querySelector('[data-yn-products-prev]')?.addEventListener('click', () => scroll(-1));
          panel.querySelector('[data-yn-products-next]')?.addEventListener('click', () => scroll(1));
        });
      });
    };

    initializeYouNickHomeProducts();
    document.addEventListener('shopify:section:load', (event) => initializeYouNickHomeProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home-v3-fit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-yn3-fit]').forEach((section) => {
      const range = section.querySelector('[data-yn3-fit-range]');
      const frame = section.querySelector('.yn3-fit__frame');
      const output = section.querySelector('[data-yn3-fit-width]');
      const stageOutput = section.querySelector('[data-yn3-fit-stage-width]');
      const size = section.querySelector('[data-yn3-fit-size]');
      const labels = section.querySelector('[data-size-s]');
      if (!range || !frame || !output || !stageOutput || !size || !labels) return;
      const update = () => {
        const value = Number(range.value);
        output.textContent = value;
        stageOutput.textContent = `${value} mm`;
        size.textContent = value <= 141 ? labels.dataset.sizeS : value <= 148 ? labels.dataset.sizeM : labels.dataset.sizeL;
        const progress = Math.max(0, Math.min(1, (value - 134) / 22));
        const frameWidth = 28 + (progress * 8);
        frame.style.setProperty('--yn3-frame-width', `${frameWidth.toFixed(2)}%`);
      };
      range.addEventListener('input', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home-v3-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroes = document.querySelectorAll('[data-yn3-hero]');
    if (!heroes.length) return;

    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const connection = navigator.connection || {};
    const slowConnection = connection.saveData === true || /(^|-)2g$/.test(connection.effectiveType || '');

    heroes.forEach((hero) => {
      const video = hero.querySelector('video');
      if (!video) return;

      if (reduceMotion || slowConnection) {
        video.preload = 'none';
        video.pause();
        return;
      }

      let wantsPlay = true;
      let canPlay = video.readyState >= 3;
      const showPoster = () => hero.classList.remove('is-video-playing');
      const showVideo = () => hero.classList.add('is-video-playing');
      const tryPlay = () => {
        if (!wantsPlay || !canPlay) return;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(showPoster);
        }
      };

      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.addEventListener('canplay', () => {
        canPlay = true;
        tryPlay();
      }, { once: true });
      video.addEventListener('playing', showVideo);
      video.addEventListener('waiting', showPoster);
      video.addEventListener('stalled', showPoster);
      video.addEventListener('error', showPoster);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            wantsPlay = entry.isIntersecting;
            if (entry.isIntersecting) {
              tryPlay();
            } else {
              video.pause();
              showPoster();
            }
          });
        }, { threshold: 0.05 });
        observer.observe(hero);
      } else {
        tryPlay();
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          video.pause();
          showPoster();
        } else {
          tryPlay();
        }
      });

      if (canPlay) {
        tryPlay();
      } else {
        video.load();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home-v3-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeYouNickReviews = (scope = document) => {
      scope.querySelectorAll('[data-yn3-reviews]').forEach((section) => {
        if (section.dataset.ynReviewsReady === 'true') return;
        section.dataset.ynReviewsReady = 'true';
        const track = section.querySelector('[data-yn3-reviews-track]');
        const cards = Array.from(track?.querySelectorAll('article') || []);
        const previous = section.querySelector('[data-yn3-reviews-prev]');
        const next = section.querySelector('[data-yn3-reviews-next]');
        const current = section.querySelector('[data-yn3-reviews-current]');
        if (!track || !cards.length || !previous || !next || !current) return;

        const step = () => cards[0].getBoundingClientRect().width + 1;
        const update = () => {
          const visibleCards = Math.max(1, Math.round(track.clientWidth / step()));
          const maxIndex = Math.max(0, cards.length - visibleCards);
          const index = Math.max(0, Math.min(maxIndex, Math.round(track.scrollLeft / step())));
          current.textContent = String(index + 1).padStart(2, '0');
          previous.disabled = index === 0;
          next.disabled = index >= maxIndex;
        };
        previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        update();
      });
    };
    initializeYouNickReviews();
    document.addEventListener('shopify:section:load', (event) => initializeYouNickReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home-v3-venus-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (!section || section.dataset.yn3VenusReady === 'true') return;
      section.dataset.yn3VenusReady = 'true';

      var video = section.querySelector('[data-yn3-venus-video]');
      var toggle = section.querySelector('[data-yn3-venus-toggle]');
      var state = section.querySelector('[data-yn3-venus-state]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!video || !toggle || !state) return;

      function update(playing) {
        var label = playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
        toggle.dataset.playing = playing ? 'true' : 'false';
        toggle.setAttribute('aria-label', label);
        state.textContent = label;
      }

      function loadVideo() {
        if (video.dataset.loaded === 'true') return;
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
        });
        video.dataset.loaded = 'true';
        video.load();
      }

      function playVideo() {
        loadVideo();
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () { update(false); });
      }

      video.addEventListener('playing', function () { update(true); });
      video.addEventListener('pause', function () { update(false); });
      toggle.addEventListener('click', function () {
        if (video.paused) playVideo();
        else video.pause();
      });

      if (!reducedMotion && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          playVideo();
        }, { rootMargin: '500px 0px' });
        observer.observe(section);
      } else if (!reducedMotion) {
        playVideo();
      }

      update(false);
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-yn3-venus-film]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
    else boot(document);
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHome = (scope = document) => {
      scope.querySelectorAll('[data-yn-home]').forEach((home) => {
        if (home.dataset.homeReady === 'true') return;
        home.dataset.homeReady = 'true';

        const tabs = Array.from(home.querySelectorAll('[data-home-tab]'));
        const panels = Array.from(home.querySelectorAll('[data-home-panel]'));
        const selectTab = (key) => {
          tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.homeTab === key)));
          panels.forEach((panel) => { panel.hidden = panel.dataset.homePanel !== key; });
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const update = () => selectTab(tab.dataset.homeTab);
            if (document.startViewTransition) document.startViewTransition(update);
            else update();
          });
        });

        const stage = home.querySelector('[data-home-stage]');
        if (stage && matchMedia('(pointer: fine)').matches) {
          stage.addEventListener('pointermove', (event) => {
            const bounds = stage.getBoundingClientRect();
            const x = (event.clientX - bounds.left) / bounds.width - 0.5;
            const y = (event.clientY - bounds.top) / bounds.height - 0.5;
            stage.style.setProperty('--stage-x', `${y * -3}deg`);
            stage.style.setProperty('--stage-y', `${x * 4}deg`);
          });
          stage.addEventListener('pointerleave', () => {
            stage.style.setProperty('--stage-x', '0deg');
            stage.style.setProperty('--stage-y', '0deg');
          });
        }

        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
        home.querySelectorAll('[data-home-reveal]').forEach((element) => revealObserver.observe(element));
      });
    };

    initializeHome();
    document.addEventListener('shopify:section:load', (event) => initializeHome(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviews = (scope = document) => {
      scope.querySelectorAll('[data-yn-reviews]').forEach((root) => {
        if (root.dataset.reviewsReady === 'true') return;
        const slides = Array.from(root.querySelectorAll('.yn-reviews__slide'));
        const previous = root.querySelector('[data-review-previous]');
        const next = root.querySelector('[data-review-next]');
        const currentLabel = root.querySelector('[data-review-current]');
        if (!slides.length || !previous || !next || !currentLabel) return;

        let current = 0;
        const show = (index) => {
          current = (index + slides.length) % slides.length;
          slides.forEach((slide, slideIndex) => {
            const active = slideIndex === current;
            slide.classList.toggle('is-active', active);
            slide.hidden = !active;
            slide.setAttribute('aria-hidden', String(!active));
          });
          currentLabel.textContent = String(current + 1).padStart(2, '0');
        };

        previous.addEventListener('click', () => show(current - 1));
        next.addEventListener('click', () => show(current + 1));
        root.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') show(current - 1);
          if (event.key === 'ArrowRight') show(current + 1);
        });
        show(0);
        root.dataset.reviewsReady = 'true';
      });
    };

    initializeReviews();
    document.addEventListener('shopify:section:load', (event) => initializeReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-smart-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSmartPages = (scope = document) => {
      scope.querySelectorAll('[data-yn-smart-page]').forEach((pageRoot) => {
        const sectionWrapper = pageRoot.closest('.shopify-section');
        if (sectionWrapper) {
          sectionWrapper.classList.add('is-visible');
          sectionWrapper.style.setProperty('opacity', '1', 'important');
          sectionWrapper.style.setProperty('transform', 'none', 'important');
        }

        if (pageRoot.dataset.ynReady === 'true') return;
        pageRoot.dataset.ynReady = 'true';

        const body = pageRoot.querySelector('[data-page-body]');
        const pageTitle = (pageRoot.dataset.pageTitle || '').trim().toLocaleLowerCase();
        const pageMode = pageRoot.dataset.pageMode || '';

        if (body) {
          if (pageMode === 'legal' || pageMode === 'partners') {
            body.querySelectorAll('style').forEach((style) => style.remove());
          }

          if (pageMode === 'why') {
            const whyRoot = body.querySelector('.yn-why');
            const video = whyRoot?.querySelector('video');
            if (video) {
              video.preload = 'metadata';
              video.setAttribute('aria-hidden', 'true');
            }

            whyRoot?.querySelectorAll('img').forEach((image) => {
              image.loading = 'lazy';
              image.decoding = 'async';
              image.fetchPriority = 'low';

              if (image.classList.contains('yn-feat-img')) {
                image.sizes = '100vw';
              } else if (image.closest('.yn-gal-grid')) {
                image.sizes = '(max-width: 480px) calc(100vw - 56px), (max-width: 760px) 50vw, 33vw';
              } else if (image.closest('.yn-cards')) {
                image.sizes = '(max-width: 760px) calc(100vw - 56px), 360px';
              } else {
                image.sizes = '(max-width: 820px) calc(100vw - 56px), 560px';
              }

              const source = image.getAttribute('src');
              if (!source || image.srcset) return;
              const url = new URL(source, window.location.href);
              const isShopifyImage = url.hostname.includes('shopify.com') || url.pathname.includes('/cdn/shop/files/');
              if (!isShopifyImage) return;
              image.srcset = [480, 720, 960, 1200, 1600].map((width) => {
                const candidate = new URL(url.href);
                candidate.searchParams.set('width', String(width));
                return `${candidate.href} ${width}w`;
              }).join(', ');
            });

            const reviews = whyRoot?.querySelector('.yn-rev-grid');
            const reviewsHeading = reviews?.closest('.yn-reviews')?.querySelector('h2');
            if (reviews && reviewsHeading) {
              reviews.tabIndex = 0;
              reviews.setAttribute('role', 'region');
              reviews.setAttribute('aria-label', reviewsHeading.textContent.trim());
            }
          }

          body.querySelectorAll('a').forEach((link) => {
            const text = (link.textContent || '').trim();
            if (!link.getAttribute('href') && text.includes('@')) {
              link.href = `mailto:${text.replace(/\s/g, '')}`;
            }
          });

          body.querySelectorAll('h1').forEach((heading) => {
            const text = (heading.textContent || '').trim().toLocaleLowerCase();
            if (text !== pageTitle) return;
            heading.dataset.ynDuplicatePageTitle = 'true';
            heading.hidden = true;
          });

          const headings = Array.from(body.querySelectorAll('h2, h3')).filter((heading) => {
            const style = getComputedStyle(heading);
            return style.display !== 'none' && (heading.textContent || '').trim();
          }).slice(0, 16);
          const rail = pageRoot.querySelector('[data-auto-nav]');
          const list = pageRoot.querySelector('[data-auto-nav-list]');

          if (rail && list && headings.length > 1) {
            headings.forEach((heading, index) => {
              if (!heading.id) heading.id = `yn-sp-heading-${index + 1}`;
              const item = document.createElement('li');
              const link = document.createElement('a');
              const number = document.createElement('span');
              number.textContent = String(index + 1).padStart(2, '0');
              link.href = `#${heading.id}`;
              link.append(number, document.createTextNode((heading.textContent || '').trim()));
              item.append(link);
              list.append(item);
            });
            rail.hidden = false;

            const links = Array.from(list.querySelectorAll('a'));
            const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
              });
            }, { rootMargin: '-24% 0px -66% 0px', threshold: 0 });
            headings.forEach((heading) => observer.observe(heading));
          }

          const words = (body.textContent || '').trim().split(/\s+/).filter(Boolean).length;
          const reading = pageRoot.querySelector('[data-reading-time]');
          if (reading) reading.textContent = `${Math.max(1, Math.ceil(words / 210))} ${pageRoot.dataset.readSuffix}`;

          const revealTargets = body.querySelectorAll('h2, h3, .ynp-card, .ynp2-card, .yn-step, .yn-card, .yn-section, .audience-card, .product');
          const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
          revealTargets.forEach((target) => {
            target.dataset.ynReveal = 'true';
            revealObserver.observe(target);
          });
        }

        const printButton = pageRoot.querySelector('[data-print-document]');
        if (printButton) printButton.addEventListener('click', () => window.print());

        const partnerSearch = pageRoot.querySelector('[data-partner-search]');
        if (partnerSearch && body) {
          const countOutput = pageRoot.querySelector('[data-partner-count]');
          const empty = pageRoot.querySelector('[data-partner-empty]');

          const filterPartners = () => {
            const cards = Array.from(body.querySelectorAll('.yn-stores__card'));
            const query = partnerSearch.value.trim().toLocaleLowerCase();
            let count = 0;
            cards.forEach((card) => {
              const match = !query || (card.textContent || '').toLocaleLowerCase().includes(query);
              card.hidden = !match;
              if (match) count += 1;
            });
            const countLabel = count === 1
              ? pageRoot.dataset.partnerCountOne
              : count >= 2 && count <= 4
                ? pageRoot.dataset.partnerCountFew
                : pageRoot.dataset.partnerCountMany || pageRoot.dataset.partnerCountLabel;
            if (countOutput) countOutput.textContent = `${count} ${countLabel}`;
            if (empty) empty.hidden = count !== 0;
          };

          partnerSearch.addEventListener('input', filterPartners);
          filterPartners();
          requestAnimationFrame(filterPartners);

          window.setTimeout(filterPartners, 180);
          window.setTimeout(filterPartners, 720);
        }
      });
    };

    initializeSmartPages();
    document.addEventListener('shopify:section:load', (event) => initializeSmartPages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-summer-finale-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSummerFinaleHomeHero = (scope = document) => {
      scope.querySelectorAll('[data-ynsf-home]').forEach((hero) => {
        if (hero.dataset.ready === 'true') return;
        hero.dataset.ready = 'true';

        const desktop = window.matchMedia
          ? window.matchMedia('(min-width: 768px)')
          : { matches: true, addEventListener: () => {} };
        const reduceMotion = window.matchMedia
          ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
          : false;
        const videos = [...hero.querySelectorAll('video')];
        const activeVideo = () => hero.querySelector(desktop.matches ? '.ynsf-home__video--desktop' : '.ynsf-home__video--mobile');
        const play = () => {
          const selectedVideo = activeVideo();
          videos.forEach((video) => {
            if (video !== selectedVideo) {
              video.pause();
              return;
            }
            if (reduceMotion) return;
            if (!video.getAttribute('src')) {
              video.setAttribute('src', video.dataset.src);
              video.load();
            }
            const attempt = video.play();
            if (attempt?.catch) attempt.catch(() => hero.classList.remove('is-video-playing'));
          });
        };
        videos.forEach((video) => {
          video.addEventListener('playing', () => hero.classList.add('is-video-playing'));
          video.addEventListener('waiting', () => hero.classList.remove('is-video-playing'));
          video.addEventListener('error', () => hero.classList.remove('is-video-playing'));
        });
        desktop.addEventListener?.('change', () => {
          hero.classList.remove('is-video-playing');
          play();
        });
        play();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSummerFinaleHomeHero(), { once: true });
    } else {
      initializeSummerFinaleHomeHero();
    }
    document.addEventListener('shopify:section:load', (event) => initializeSummerFinaleHomeHero(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["younick-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-yn-video-hero] video').forEach((video) => video.pause());
  })();

  } catch(e) { console.error(e); }
})();
})();
